<table mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-100">
    <!-- Task Column -->
    <!-- Task Column Definition -->
    <ng-container matColumnDef="Task">

        <!-- Header Cell -->
        <th mat-header-cell *matHeaderCellDef> Task </th>

        <!-- Data Cell -->
        <td mat-cell *matCellDef="let element" [ngClass]="{ 'phase': element?.phase?.risk }">

            <!-- Container -->
            <div class="container-fluid">

                <!-- Row -->
                <div class="task-row" [ngClass]="{
               'indent-row': !element?.phase?.risk 
             }">

                    <!-- Icon Column -->
                    <div class="icon-col">
                        <button class="toggle-button white-button" (click)="toggleExpand(element.phase.id)">
                            <mat-icon>
                                {{ expandedId === element.phase.id ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </button>
                    </div>

                    <!-- Data Column -->
                    <div class="data-col">
                        {{ element.phase.id }}
                        {{ element.phase.name }}
                    </div>

                </div> <!-- End of Row -->

            </div> <!-- End of Container -->

        </td> <!-- End of Data Cell -->

    </ng-container>

    <!-- Time Column -->
    <ng-container matColumnDef="Time">
        <th mat-header-cell *matHeaderCellDef> Time </th>
        <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element?.phase?.risk">
                <div class="green-chip">
                    {{element.phase.timeInteger}} {{element.phase.timeUnit}}
                </div>
            </ng-container>
            <ng-container *ngIf="!element?.phase?.risk">
                <div class="green-chip">
                    {{element.phase.timeOriginal}}
                </div>
            </ng-container>
            <!-- <div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-auto p-0">
                            <mat-form-field>
                                <input matInput type="number" min="0" placeholder="Estimated time"
                                    matTooltip="In Development" [(ngModel)]="element.phase.timeInteger"
                                    [disabled]="true">
                            </mat-form-field>
                        </div>
                        <div *ngIf="element.phase.timeInteger > 1" class="col-md-auto w-25">
                            <mat-form-field>
                                <mat-select [(value)]="element.phase.timeUnit" [disabled]="true"
                                    matTooltip="In Development">
                                    <mat-option value="weeks">Weeks</mat-option>
                                    <mat-option value="days">Days</mat-option>
                                    <mat-option value="months">Months</mat-option>
                                    <mat-option value="years">Years</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="!(element.phase.timeInteger > 1)" class="col-md-auto w-25">
                            <mat-form-field>
                                <mat-select [(value)]="element.phase.timeUnit" [disabled]="true"
                                    matTooltip="In Development">
                                    <mat-option value="week">Week</mat-option>
                                    <mat-option value="day">Day</mat-option>
                                    <mat-option value="month">Month</mat-option>
                                    <mat-option value="year">Year</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div> -->
        </td>
    </ng-container>

    <!-- Risk Column -->
    <ng-container matColumnDef="Risk">
        <th mat-header-cell *matHeaderCellDef> Risk </th>
        <td mat-cell *matCellDef="let element">
            <div [ngClass]="{'red-chip': element?.phase?.risk === 'high',
                    'yellow-chip': element?.phase?.risk === 'medium',
                    'green-chip': element?.phase?.risk === 'low'
                    }" matTooltip="{{ element.phase.level }}">
                {{ element.phase.risk }}
            </div>
        </td>
    </ng-container>

    <!-- Auto-Edit Column -->
    <ng-container matColumnDef="Auto-Edit">
        <th mat-header-cell *matHeaderCellDef> Auto-Edit </th>
        <td mat-cell *matCellDef="let element" [ngClass]="{ 'phase': element?.phase?.autoedit }">
            <div *ngIf="element?.phase?.risk">
                <button class="material-icons white-button" (click)="add(element.phase.id)"
                    [disabled]="(isLoading$ | async)?.show" matTooltip="Add a new generated phase following this stage">
                    add_circle_outline</button>
                <button class="material-icons white-button" (click)="remove(element.phase.id)"
                    [disabled]="(isLoading$ | async)?.show" matTooltip="Remove this phase from the table">
                    remove_circle_outline</button>
                <button class="material-icons white-button" (click)="regenerate(element.phase.id)"
                    [disabled]="(isLoading$ | async)?.show"
                    matTooltip="Regenerate this phase along with its associated milestones">
                    auto_fix_high</button>
                <button class="material-icons white-button" (click)="instruct(element.phase.id)"
                    [disabled]="(isLoading$ | async)?.show"
                    matTooltip="Regenerate this phase by giving further instructions">
                    chat</button>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div class="example-element-detail"
                [@detailExpand]="element.phase.id === expandedId ? 'expanded' : 'collapsed'">

                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg">
                            {{element.phase.details}}
                        </div>
                        <ng-container *ngIf="!element?.phase?.risk">
                            <div class="col-md-auto">
                                <div class="vertical-line"></div>
                            </div>
                            <ng-container *ngIf="!(disableGantChart$ | async)">
                                <div class="col-lg">
                                    Dependencies: {{element.phase.dependencies}}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="(disableGantChart$ | async)">
                                <div class="col-lg">
                                    Dependencies: <i>supported for up to 4 phases</i>
                                </div>
                            </ng-container>
                            <div class="col-md-auto">
                                <div class="vertical-line"></div>
                            </div>
                            <ng-container *ngIf="!(disableGantChart$ | async)">
                                <div class="col-lg">
                                    Synergies: {{element.phase.synergies}}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="(disableGantChart$ | async)">
                                <div class="col-lg">
                                    Synergies: <i>supported for up to 4 phases</i>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </td>
    </ng-container>

    <!-- Table structure -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
        [class.example-expanded-row]="expandedId === element.phase.id">
    </tr>
    <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="example-detail-row">
    </tr>

</table>